<div class="movement-report-container">
  <h2>{{ 'webPos.MovementReport' | translate }}</h2>
  <form class="form-inline" [formGroup]="reportForm" (ngSubmit)="search()">
    <div class="form__content-side-form-row">
      <div class="form__content-side-form-row-item">
        <app-form-input [label]="'webPos.DateFrom' | translate" [type]="FormInputType.Date" formControlName="dateFrom"></app-form-input>
      </div>
      <div class="form__content-side-form-row-item">
        <app-form-input [label]="'webPos.DateTo' | translate" [type]="FormInputType.Date" formControlName="dateTo"></app-form-input>
      </div>
      <div class="form__content-side-form-row-item">
        <app-form-input [label]="'webPos.BnrVs' | translate" formControlName="bnrVs"></app-form-input>
      </div>
    </div>
    <div class="form__content-side-form-row">
      <div class="form__content-side-form-row-item">
        <app-form-input [label]="'webPos.AmountFrom' | translate" [type]="FormInputType.Number" formControlName="amountFrom"></app-form-input>
      </div>
      <div class="form__content-side-form-row-item">
        <app-form-input [label]="'webPos.AmountTo' | translate" [type]="FormInputType.Number" formControlName="amountTo"></app-form-input>
      </div>
      <div class="form__content-side-form-row-item tender-type-select">
        <app-dropdown [label]="'webPos.TenderType' | translate" [options]="tenderTypes" formControlName="tenderType"></app-dropdown>
      </div>
      <div class="form__content-side-form-row-item">
        <app-card-button
          [buttonSize]="CardButtonSize.Inline"
          [buttonIcon]="['fas', 'search']"
          [buttonBackground]="CardButtonBackground.Primary"
          (clicked)="search()">
          {{ 'webPos.Search' | translate }}
        </app-card-button>
      </div>
    </div>
  </form>

  <div class="report-actions">
    POUZE PLACEHOLDER
  </div>

  <!-- <iframe name="report-iframe" *ngIf="reportUrl" [src]="reportUrl | safeUrl" class="report-iframe"></iframe> -->
</div>
